(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.announcement-bar__item'));
      this.current = 0;
      this.prevBtn = this.querySelector('.announcement-bar__arrow--prev');
      this.nextBtn = this.querySelector('.announcement-bar__arrow--next');
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.show(this.current - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.show(this.current + 1));

      this.carouselDesktop = this.dataset.carouselDesktop === 'true';
      this.autoplay = this.dataset.autoplay === 'true';

      this.applyColors(this.items[this.current]);
      this.initCountdowns();
      this.updateSpacer();
      window.addEventListener('resize', () => this.updateSpacer());

      if (this.autoplay && this.items.length > 1 && this.shouldCarousel()) {
        this.scheduleNext();
      }
    }

    shouldCarousel() {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      return !isDesktop || this.carouselDesktop;
    }

    scheduleNext() {
      clearTimeout(this.timer);
      if (!this.shouldCarousel()) return;
      const activeItem = this.items[this.current];
      const readTime = Number(activeItem.dataset.readTime) || Number(this.dataset.defaultInterval) || 5000;
      this.timer = setTimeout(() => this.show(this.current + 1), readTime);
    }

    applyColors(item) {
      if (!item) return;
      const { bgColor, textColor, linkColor } = item.dataset;
      this.toggleColorProperty('--announcement-bg', bgColor);
      this.toggleColorProperty('--announcement-text', textColor);
      this.toggleColorProperty('--announcement-link', linkColor);
    }

    toggleColorProperty(name, value) {
      if (value) {
        this.style.setProperty(name, value);
      } else {
        this.style.removeProperty(name);
      }
    }

    updateSpacer() {
      if (!this.classList.contains('announcement-bar--sticky')) return;
      const spacer = document.querySelector('[data-announcement-spacer]');
      if (spacer) spacer.style.height = `${this.offsetHeight}px`;
    }

    show(index) {
      const total = this.items.length;
      const next = (index + total) % total;
      this.items[this.current].hidden = true;
      this.items[this.current].classList.remove('is-active');
      this.items[next].hidden = false;
      this.items[next].classList.add('is-active');
      this.current = next;
      this.applyColors(this.items[next]);
      this.updateSpacer();
      if (this.autoplay) this.scheduleNext();
    }

    initCountdowns() {
      this.querySelectorAll('[data-countdown]').forEach((el) => {
        if (el.dataset.initialized) return;
        el.dataset.initialized = 'true';

        const getTarget = () => {
          if (el.dataset.countdownType === 'evergreen') {
            const key = el.dataset.storageKey;
            const durationMs = (Number(el.dataset.durationMinutes) || 60) * 60000;
            let start = Number(window.localStorage.getItem(key));
            const now = Date.now();
            if (!start || now - start > durationMs) {
              start = now;
              try {
                window.localStorage.setItem(key, String(start));
              } catch (e) {
                /* storage unavailable, countdown still works for this page view */
              }
            }
            return start + durationMs;
          }
          const { endYear, endMonth, endDay, endHour, endMinute, timezoneOffset } = el.dataset;
          const iso = `${endYear}-${String(endMonth).padStart(2, '0')}-${String(endDay).padStart(2, '0')}T${String(endHour).padStart(2, '0')}:${String(endMinute).padStart(2, '0')}:00${timezoneOffset}`;
          return new Date(iso).getTime();
        };

        const update = () => {
          const target = getTarget();
          const diff = target - Date.now();
          if (diff <= 0 && el.dataset.countdownType !== 'evergreen') {
            el.textContent = '00d 00h 00m 00s';
            return;
          }
          const safeDiff = Math.max(diff, 0);
          const days = Math.floor(safeDiff / 86400000);
          const hours = Math.floor((safeDiff % 86400000) / 3600000);
          const minutes = Math.floor((safeDiff % 3600000) / 60000);
          const seconds = Math.floor((safeDiff % 60000) / 1000);
          el.textContent = `${String(days).padStart(2, '0')}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
        };

        update();
        setInterval(update, 1000);
      });
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }
  }
  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complementary-products"] && !Shopify.designMode) return;
  try {
    
  class ComplementaryProducts extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.load();
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) throw new Error(response.status);

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const container = doc.querySelector('.complementary-products');

        // No container means the product has no complementary products set.
        // Remove the element rather than leaving it in the DOM: it has no
        // purpose once we know there is nothing to show, and leaving it means
        // a section:load event re-runs the same empty fetch.
        if (!container) {
          this.remove();
          return;
        }

        this.insertAdjacentElement('beforebegin', container);
        this.dataset.loaded = 'true';
      } catch (error) {
        this.remove();
      }
    }
  }

  if (!customElements.get('complementary-products')) {
    customElements.define('complementary-products', ComplementaryProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.loadRecommendations();
    }

    async loadRecommendations() {
      try {
        const response = await fetch(this.dataset.url);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const container = doc.querySelector('.product-recommendations');
        if (container) {
          this.insertAdjacentElement('beforebegin', container);
        }
      } catch (error) {
        this.remove();
      }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  /* Panels are all in the DOM; tabs only toggle the hidden attribute so the
     products in an inactive tab stay crawlable. Implements the WAI-ARIA tabs
     keyboard pattern: arrows move, Home and End jump, roving tabindex. */
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.tabs = Array.from(this.querySelectorAll('[data-tab-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
      if (!this.tabs.length) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (this.panels[i]) this.panels[i].hidden = !active;
      });
      this.tabs[index].focus();
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.select(next);
    }
  }

  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', ProductTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
